export default __webpack_public_path__ + "static/media/422.ec7dd0d4.png";